import { render, staticRenderFns } from "./AntiTheftBtn.vue?vue&type=template&id=b51aa98e&scoped=true"
import script from "./AntiTheftBtn.vue?vue&type=script&lang=ts"
export * from "./AntiTheftBtn.vue?vue&type=script&lang=ts"
import style0 from "./AntiTheftBtn.vue?vue&type=style&index=0&id=b51aa98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51aa98e",
  null
  
)

export default component.exports